import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";

import "./ProfileGridChoice.scss";

function ProfileGridChoice(props) {
  
  const user = useSelector((props) => props.appReducer.userDataReducer.data);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

    let { label_name, summary, disabled, uri } = props;
    if (uri === "/dashboard/profiles/worksite") {
      uri = "/dashboard/profiles";
    }
    const renderProfileButton = () => (
      <Link to={uri} style={{ marginTop: "auto" }}>
        <button className={"usa-button application-button"} disabled={disabled}>
          {!disabled ? "View All" : "Coming Soon"}
        </button>
      </Link>
    );

    return (
      <div className="profile-container" style={{ padding: "0 40px 40px 0" }}>
        <Link to={uri} style={{ color: "black" }}>
          <div className="usa-profile-box">
            <div>
              <h4 className="profile-title">
                <br />
                {label_name}
                {/* in line below, removed this text on 05/08/2019 AK 'placeholder for profile type count' */}
                <p className="profile-count" />
              </h4>
              <p>{summary}</p>
            </div>
            {renderProfileButton()}
          </div>
        </Link>
      </div>
    );
  }
export default ProfileGridChoice;
